/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBOMRequest
 */
export interface APIBOMRequest {
    /**
     * 
     * @type {string}
     * @memberof APIBOMRequest
     */
    rootAccount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIBOMRequest
     */
    parent: string;
    /**
     * 
     * @type {string}
     * @memberof APIBOMRequest
     */
    child: string;
    /**
     * 
     * @type {number}
     * @memberof APIBOMRequest
     */
    amount?: number;
}

/**
 * Check if a given object implements the APIBOMRequest interface.
 */
export function instanceOfAPIBOMRequest(value: object): value is APIBOMRequest {
    if (!('parent' in value) || value['parent'] === undefined) return false;
    if (!('child' in value) || value['child'] === undefined) return false;
    return true;
}

export function APIBOMRequestFromJSON(json: any): APIBOMRequest {
    return APIBOMRequestFromJSONTyped(json, false);
}

export function APIBOMRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBOMRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rootAccount': json['root_account'] == null ? undefined : json['root_account'],
        'parent': json['parent'],
        'child': json['child'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function APIBOMRequestToJSON(value?: APIBOMRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'root_account': value['rootAccount'],
        'parent': value['parent'],
        'child': value['child'],
        'amount': value['amount'],
    };
}

